export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      icon: 'ri-search-line',
      title: 'Diagnostic & Stratégie',
      description: 'Audit de votre marché et définition de la roadmap d\'acquisition sur-mesure.',
    },
    {
      number: '02',
      icon: 'ri-rocket-line',
      title: 'Déploiement des leviers',
      description: 'Mise en place des canaux les plus adaptés pour générer un flux de visiteurs qualifiés.',
    },
    {
      number: '03',
      icon: 'ri-line-chart-line',
      title: 'Optimisation conversion',
      description: 'Transformation des visiteurs en leads grâce à des tunnels et pages optimisés.',
    },
    {
      number: '04',
      icon: 'ri-settings-3-line',
      title: 'Automatisations & Relances',
      description: 'CRM, séquences emails et relances automatiques pour maximiser chaque opportunité.',
    }
  ];

  return (
    <section className="relative py-16 sm:py-24 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e0264f2fdb3c6406bf2e4e1f66436876.jpg"
          alt=""
          className="w-full h-full object-cover object-center opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-50/80 via-white/60 to-white/90"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            4 semaines pour mettre en place votre système d'acquisition client
          </h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto">
            30 jours pour installer votre système d'acquisition client
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative group">
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 sm:p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full hover:-translate-y-1">
                {/* Icon + Number */}
                <div className="relative mb-5 flex justify-center">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center group-hover:scale-105 transition-transform duration-300 shadow-md">
                    <i className={`${step.icon} text-2xl text-white`}></i>
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gray-900 text-white flex items-center justify-center font-bold text-xs">
                    {step.number}
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 text-center">
                  {step.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed text-center">
                  {step.description}
                </p>
              </div>

              {/* Arrow */}
              {index < steps.length - 1 && (
                <div className="hidden lg:flex absolute top-1/3 -right-4 z-10 w-8 h-8 items-center justify-center">
                  <i className="ri-arrow-right-line text-2xl text-orange-400"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
